import React, { useCallback } from 'react';
import { useSelector } from '@xstate/react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PageHeader } from '@chargify/custom-ui-components';
import { useDeviceInfo } from '@chargify/device-provider';

import { useServices } from '../../hooks';
import { subscriptionsSelectors } from '../../machines';

import { PaymentProfilesContainer } from '../../containers';
import {
  ChangePaymentMethodModal,
  CreatePaymentProfileModal,
  DeletePaymentMethodModal,
  PreviewPaymentMethod,
} from '../../modals';
import { PaymentProfilesProvider } from '../../providers';

const PaymentProfiles = () => {
  const { t } = useTranslation(['subscriptions-manager']);
  const { subscriptionId, catalogId } = useParams();
  const { subscriptionsService } = useServices();
  const { device } = useDeviceInfo();
  const isOnMobileDevice = ['tablet', 'mobile'].includes(device);

  const { subscription } = useSelector(
    subscriptionsService,
    useCallback(
      subscriptionsSelectors.getSubscriptionById(
        Number(catalogId),
        Number(subscriptionId)
      ),
      []
    )
  );

  return (
    <PaymentProfilesProvider>
      <PageHeader
        title={t('payment_profile.billing_info')}
        subtitle={subscription?.product.name}
        size={isOnMobileDevice ? 'small' : 'medium'}
      />
      <PaymentProfilesContainer
        catalogId={Number(catalogId)}
        subscriptionId={Number(subscriptionId)}
      />
      <DeletePaymentMethodModal />
      <PreviewPaymentMethod />
      <ChangePaymentMethodModal />
      <CreatePaymentProfileModal />
    </PaymentProfilesProvider>
  );
};

export default PaymentProfiles;
